<script setup>
// Newsletter sign-up block for content pages — currently used only by the Academy
// "Keep up to date with our programs" CTA at the foot of each program page. Thin wrapper
// over the shared StayInformed banner, rendered in `inline` mode so the form's real markup
// lands in our DOM and the scoped CSS below can strip its FormAssembly branding.
// Defaults target the programs form (formId 4751235); a block may override
// heading/bullets/formId.
import StayInformed from '@/components/StayInformed.vue'

defineProps({
  block: { type: Object, required: true },
  // { heading?, bullets?: [string], formId?, formBaseUrl? }
})
</script>

<template>
  <div class="newsletter-block">
    <StayInformed
      inline
      :heading="block.heading || 'Keep up to date with our programs'"
      :bullets="block.bullets || []"
      :formId="block.formId || '4751235'"
      :formBaseUrl="block.formBaseUrl || 'https://www.tfaforms.com'"
    />
  </div>
</template>

<style lang="scss" scoped>
// StayInformed carries its own centred page container (max-width + gutter).
// Inside ContentPage's already-constrained `.blocks` column that would inset
// the banner by an extra gutter, making it narrower than sibling blocks — so
// neutralise its container here and let it fill the column edge-to-edge.
.newsletter-block :deep(.stay-informed) {
  max-width: none;
  padding-inline: 0;
}

// Inline-embedded FormAssembly programs form (id 4751235). The card surface and full
// field/input/validation/submit styling live in StayInformed (`.signup.inline`), shared
// with the Home newsletter form. All that's form-specific here now is hiding FA's own
// "Contact Information" footer — FA chrome, not removable in the builder.
//
// The form's in-FA branding blocks (#tfa_6 top banner, #tfa_10 "Stay Up To Date" heading +
// intro, #tfa_11-D opt-in checkboxes) were deleted in the FormAssembly builder (jk-25,
// 2026-08-14), so the CSS that used to hide them is gone — the form now emits only the five
// contact fields (name/email/phone/postcode), the Privacy Policy note, and submit.
.newsletter-block :deep(.signup.inline) {
  .wFormFooter {  // FormAssembly's "Contact Information" support link below submit
    display: none !important;
  }
}
</style>
